import { useState } from 'react';

const faqs = [
  {
    question: '萝卜视频适合哪些人群使用？',
    answer: '萝卜视频适合所有需要制作视频内容的用户，包括短视频创作者、自媒体运营者、企业营销人员、教育培训机构、电商卖家等。无论你是零基础的新手还是经验丰富的专业剪辑师，萝卜视频都能帮你提升创作效率。',
  },
  {
    question: '萝卜视频的AI配音效果怎么样？声音自然吗？',
    answer: '萝卜视频的AI配音基于最新的深度学习语音合成技术，支持超过50种语言和200多种声音风格。我们不断优化语音模型，目前的配音效果非常自然流畅，语气和情感表达丰富，在盲测中超过90%的听众无法分辨是AI生成的配音。你可以在官网试听各种声音样本。',
  },
  {
    question: '使用萝卜视频需要下载安装吗？',
    answer: '萝卜视频提供网页版和桌面客户端两种使用方式。网页版无需下载安装，直接在浏览器中使用全部功能。桌面客户端支持Windows和macOS系统，提供更强大的本地渲染能力和离线使用体验。你可以根据自己的需求选择最合适的方式。',
  },
  {
    question: '萝卜视频支持哪些视频格式和分辨率？',
    answer: '萝卜视频支持几乎所有主流视频格式的导入，包括MP4、MOV、AVI、MKV、WMV等。导出方面支持720P到4K多种分辨率，以及24fps、30fps、60fps多种帧率选择。编码格式支持H.264和H.265，满足不同场景的发布需求。',
  },
  {
    question: '免费版和付费版有什么区别？',
    answer: '萝卜视频免费版包含基础的AI剪辑、配音和字幕功能，每月可导出5条视频（带水印）。专业版解锁全部AI功能，支持无水印导出、4K分辨率、优先渲染队列等，月费仅需一杯咖啡的价格。团队版还支持多人协作、品牌定制模板等企业级功能。详细对比请查看定价页面。',
  },
  {
    question: '我的视频素材安全吗？会不会被泄露？',
    answer: '数据安全是我们的首要任务。萝卜视频采用银行级加密技术保护你的视频素材，所有上传的文件都存储在安全隔离的云端环境中。我们严格遵守隐私保护政策，不会以任何方式使用、分享或出售你的视频内容。你可以随时删除存储在云端的所有数据。',
  },
  {
    question: '可以多人协作编辑同一个视频项目吗？',
    answer: '是的，萝卜视频团队版支持多人实时协作编辑。团队成员可以同时在线编辑同一个项目，所有修改实时同步。项目还支持版本历史管理，你可以随时回溯到之前任意版本。这对于企业营销团队、MCN机构等多人协作场景非常实用。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              常见问题解答
            </h2>
            <p className="text-foreground-600 text-base">
              关于萝卜视频，你可能想了解的问题都在这里
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="rounded-lg border border-background-200/70 bg-background-100 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left cursor-pointer"
                  aria-expanded={openIndex === index}
                >
                  <span className="text-base font-medium text-foreground-900">
                    {faq.question}
                  </span>
                  <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-200 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                    ></i>
                  </span>
                </button>
                <div
                  className={`px-6 overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'pb-5 max-h-96' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}